import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { authorizeClient, client, loginClient } from '../../networking/client';
import { RootState } from '../store';
import { Buffer } from 'buffer';
import api from './api';
import { ADMIN_USER_ROLE, DOCTOR_USER_ROLE } from '../../constants/userRolesConstants';

export interface IAccountInfo {
  account_number: string;
  external_person_id?: number;
  account_id?: number;
  serves_diagnostics: boolean;
  serves_consultations: boolean;
  performs_sick_leave: boolean;
  performs_vital_signs: boolean;
  performs_examinations: boolean;
  performs_ecg: boolean;
  performs_other_services: boolean;
  supports_chat: boolean;
  consultation_with_extra_steps: boolean;
  personIdCreate?: string;
}

export interface ITimeSlotInfo {
  available: number;
  capacity: number;
  start: Date;
  end: Date;
}

export interface IPerson {
  person_id: string;
  person_firstname: string;
  person_lastname: string;
  person_external_id: string;
  role_name?: string | null;
  role_id?: number | string | null;
}
export interface IDirtyState {
  isDirty: boolean;
  isModalOpen: boolean;
  component: string;
}
export interface AuthState {
  status: string;
  isLoggedIn: boolean;
  isMerchant: boolean | undefined;
  isHealthpoint: boolean | undefined;
  person: {};
  paymentMethods: string[];
  timeSlots: ITimeSlotInfo[];
  productTimeSlots: ITimeSlotInfo[];
  productTimeSlotsStatus: string;
  accountInfo: IAccountInfo;
  role: string;
  publicDesignationId: number | undefined;
  personLoggedIn: IPerson | undefined;
  locationId: string;
  location: string;
  businessPartnerId: string;
  personsInLocation: IPerson[];
  basicAuth: string;
  merchantPersonId: string;
  isDirtyState: IDirtyState;
}

export interface ILocationServiceInfo {
  service_id: number;
  service_name: string;
  service_type_id: number;
  products: {
    product_id: number;
    product_name: string;
  }[];
  service_features: {
    service_group_id: number;
    service_group_name: string;
  }[];
}

const initialState: AuthState = {
  status: 'idle',
  isLoggedIn: false,
  isMerchant: undefined,
  isHealthpoint: undefined,
  person: {},
  paymentMethods: [],
  accountInfo: {
    account_number: '',
    serves_consultations: false,
    serves_diagnostics: false,
    supports_chat: false,
    performs_sick_leave: false,
    performs_vital_signs: false,
    performs_ecg: false,
    performs_examinations: false,
    performs_other_services: false,
    consultation_with_extra_steps: false,
  },
  timeSlots: [],
  productTimeSlots: [],
  productTimeSlotsStatus: 'idle',
  role: '',
  publicDesignationId: undefined,
  personLoggedIn: undefined,
  locationId: '',
  location: '',
  businessPartnerId: '',
  personsInLocation: [],
  basicAuth: '',
  merchantPersonId: '',
  isDirtyState: { isDirty: false, isModalOpen: false, component: '' },
};

interface loginBodyParams {
  username: string;
  password: string;
}

export const login = createAsyncThunk(
  'user/login',
  async (loginParams: loginBodyParams, { dispatch, rejectWithValue }) => {
    try {
      // const loginResponse: any = await client.post('/login-ebaas', {
      //   email: loginParams.username?.trim(),
      //   password: loginParams.password?.trim(),
      // });
      const authorizeResponse: any = await authorizeClient.get('/ident/oauth/authorize');
      const idpState = authorizeResponse.data?.idp_state ?? '';

      await loginClient.post('/ident/oauth/login', {
        username: loginParams.username?.trim(),

        password: loginParams.password?.trim(),
        idp_state: idpState,
      });
      const authorizeResponse2: any = await authorizeClient.get('/ident/oauth/authorize');
      const person = authorizeResponse2.data?.person;
      if (!person?.is_healthpoint) {
        await authorizeClient.get('/ident/oauth/logout');
        dispatch(logout());
        return rejectWithValue({
          isHealthpoint: false,
          error: 'Access restricted: Only merchants can log into HealthPoint.',
        });
      }

      // if (person?.is_merchant === false) {
      //   throw Error('Access restricted: Only merchants can log into HealthPoint.');
      // }
      return {
        role: 'admin',
        location: '',
        locationId: '',
        isMerchant: person?.is_merchant,
        isHealthpoint: person?.is_healthpoint,
      };
      // const loginResponse: any = await client.post('/login-ebaas', {
      //   email: loginParams.username?.trim(),
      //   password: loginParams.password?.trim(),
      // });
      // if (loginResponse?.data?.role === 'admin') {
      //   await dispatch(getAccountInfo());
      //   await dispatch(getPaymentMethods());
      //   await dispatch(getTimeSlots());
      //   await dispatch(getPersonsInLocation({ locationId: loginResponse?.data?.locationId }));
      // }
      // return {
      //   role: loginResponse?.data?.role,
      //   location: loginResponse?.data?.location,
      //   locationId: loginResponse?.data?.locationId,
      // };
    } catch (err: any) {
      if (err?.response?.data?.error_code === 3000307) {
        return rejectWithValue({
          isHealthpoint: false,
          error: 'Access restricted: Only merchants can log into HealthPoint.',
        });
      }
      return rejectWithValue({
        error: err?.response?.data?.error_text || 'Something went wrong.',
      });
    }
  }
);

export const sendResetPasswordRequest = (email: string) => {
  return async (dispatch: any) => {
    try {
      const authorizeResponse: any = await authorizeClient.get('/ident/oauth/authorize');
      const idpState = authorizeResponse.data?.idp_state ?? '';

      await api.post('/ident/oauth/reset_password', {
        idp_state: idpState,
        email_address: email,
      });
    } catch (error: any) {
      if (error.response.status === 401) {
        localStorage.setItem('tokenidp', error.response.data.idp_state);
        localStorage.setItem('error', error.response.status);
      } else localStorage.setItem('error', error.response.status);
    }
  };
};
export const verify = (data: any) => {
  return async (dispatch: any) => {
    const authorizeResponse: any = await authorizeClient.get('/ident/oauth/authorize');
    const idpState = authorizeResponse.data?.idp_state ?? '';
    try {
      await api.post('/ident/oauth/verify', {
        ...data,
        idp_state: idpState,
      });
    } catch (error: any) {
      if (error.response.status === 401) {
        localStorage.setItem('tokenidp', error.response.data.idp_state);
        localStorage.setItem('verify-error', error.response.status);
      } else localStorage.setItem('verify-error', error.response.status);
    }
  };
};
export const authorize = () => {
  return async (dispatch: any) => {
    try {
      const response = await api.get('/ident/oauth/authorize');
      return response.data.idp_state;
    } catch (error: any) {
      if (error.response.status === 401) {
        localStorage.setItem('authorize-error', error.response.status);
      } else {
        localStorage.setItem('authorize-error', error.response.status);
      }
    }
  };
};
export const setPassword = (data: any) => {
  return async (dispatch: any) => {
    try {
      // await dispatch(authorize());
      const response: any = await api.post('/ident/oauth/set_password', {
        ...data,
        idp_state: localStorage.getItem('tokenidp'),
      });
      localStorage.setItem('set-password-error', response?.status);
    } catch (error: any) {
      if (error.response.status === 401) {
        localStorage.setItem('set-password-error', error.response.status);
      } else {
        localStorage.setItem('set-password-error', error.response.status);
      }
    }
  };
};

export const validateToken = createAsyncThunk(
  'user/validate',
  async (_, { dispatch, rejectWithValue, getState }) => {
    try {
      // const validateTokenResponse: any = await client.get('/validate-token');
      const authorizeResponse: any = await authorizeClient.get('/ident/oauth/authorize');
      const person = authorizeResponse.data?.person;
      if (person?.is_healthpoint) {
        return { person: {} };
      } else {
        throw Error('Invalid token.');
      }
      // const validateTokenResponse: any = await client.get('/validate-token');
      // const person = authorizeResponse.data?.person;
      // const tokenResponse: any = await loginClient.get('/core/person/authorization');
      // return { person: person };
      // const state: any = getState();
      // if (!state?.auth?.role) {
      //   throw Error('Invalid token.');
      // }
      // if (state?.auth?.role === 'admin') {
      //   await dispatch(getAccountInfo());
      //   await dispatch(getPaymentMethods());
      //   await dispatch(getTimeSlots());
      //   await dispatch(getPersonsInLocation({}));
      // }
      // return { person: {} };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const allInfo = createAsyncThunk(
  'user/all-info',
  async (_, { dispatch, rejectWithValue, getState }) => {
    try {
      const accountInfoResponse: any = await authorizeClient.get('/core/account');
      const authInfoResponse: any = await authorizeClient.get('/ident/oauth/authorize');
      let locationResponse: any;
      try {
        locationResponse = await client.get(
          `/healthpoint/location/${accountInfoResponse?.data?.person_id}`
        );
      } catch (err: any) {
        if (err.response?.status === 401) {
          // If location is not mapped with merchant in hp
          await authorizeClient.get('/ident/oauth/logout');
          dispatch(logout());
          return rejectWithValue({
            isHealthpoint: false,
            error: 'Access restricted: Only merchants can log into HealthPoint.',
          });
        }
        throw err; // Rethrow other errors
      }
      const getPaymentMethodsResponse: any = await authorizeClient.get(
        `/core/merchant/${locationResponse?.data?.location?.location_external_id}/payment_method`
      );
      const personsByLocationResponse: any = await client.get(
        `/healthpoint/persons-in-location/${locationResponse?.data?.location?.location_id}`
      );
      const getServicesResponse = await client.get(
        `/healthpoint/services/${locationResponse?.data?.location?.location_id}`
      );
      let hasDiagnostics = false;
      let hasConsultations = false;
      let hasChat = false;
      let hasVitalSigns = false;
      let hasExaminations = false;
      let hasEcg = false;
      let hasOtherServices = false;
      if (
        getServicesResponse.data?.services &&
        getServicesResponse.data.services.length > 0 &&
        getServicesResponse.data.services[0]?.location_service_list?.service_list &&
        getServicesResponse.data.services[0]?.location_service_list?.service_list.length > 0
      ) {
        const serviceList: ILocationServiceInfo[] = getServicesResponse.data.services
          ? getServicesResponse.data.services[0].location_service_list.service_list
          : [];
        hasConsultations = serviceList.find(
          (sl) =>
            sl.service_features?.length > 0 &&
            (sl.service_features[0].service_group_id === 3 ||
              sl.service_features[0].service_group_id === 7 ||
              sl.service_features[0].service_group_id === 8 ||
              sl.service_features[0].service_group_id === 11)
        )
          ? true
          : false;
        hasDiagnostics =
          serviceList.find(
            (sl) =>
              sl.service_features?.length > 0 &&
              (sl.service_features[0].service_group_id === 1 ||
                sl.service_features[0].service_group_id === 4)
          ) !== undefined
            ? true
            : false;
        hasChat = serviceList.find(
          (sl) => sl.service_features?.length > 0 && sl.service_features[0].service_group_id === 10
        )
          ? true
          : false;
        hasVitalSigns = serviceList.find((sl) => sl.service_type_id === 5) ? true : false;
        hasExaminations = serviceList.find((sl) => sl.service_type_id === 6) ? true : false;
        hasEcg = serviceList.find((sl) => sl.service_type_id === 7) ? true : false;
        hasOtherServices = serviceList.find((sl) => sl.service_type_id === 3) ? true : false;
      }
      let storedLang = localStorage.getItem('lang');
      if (accountInfoResponse.data.language !== storedLang) {
        localStorage.setItem('lang', accountInfoResponse.data.language?.toLowerCase());
      }
      return {
        location: locationResponse?.data?.location?.location_name,
        locationId: locationResponse?.data?.location?.location_id,
        businessPartnerId: locationResponse?.data?.location?.business_partner_id,
        role: locationResponse?.data?.location?.role_name,
        publicDesignationId: locationResponse?.data?.location?.public_designation_id
          ? parseInt(locationResponse?.data?.location?.public_designation_id)
          : undefined,
        personLoggedIn: {
          person_id: locationResponse?.data?.location?.person_id,
          person_firstname: locationResponse?.data?.location?.person_firstname,
          person_lastname: locationResponse?.data?.location?.person_lastname,
          person_external_id: locationResponse?.data?.location?.person_external_id,
        } as IPerson,
        isLoggedIn: true,
        isMerchant: authInfoResponse?.data?.person?.is_merchant,
        isHealthpoint: authInfoResponse?.data?.person?.is_healthpoint,
        paymentMethods: getPaymentMethodsResponse?.data,
        accountInfo: {
          account_number: locationResponse?.data?.location?.location_external_id,
          external_person_id: personsByLocationResponse?.data?.persons?.find(
            (p: any) => p.role_id == 4
          ).person_external_id,
          personIdCreate: authInfoResponse?.data?.person?.person_id,
          account_id: accountInfoResponse?.data?.account_id,
          serves_consultations: hasConsultations,
          serves_diagnostics: hasDiagnostics,
          supports_chat: hasChat,
          performs_sick_leave:
            locationResponse?.data?.location?.role_name === DOCTOR_USER_ROLE ||
            locationResponse?.data?.location?.role_name === ADMIN_USER_ROLE,
          performs_vital_signs: hasVitalSigns,
          performs_examinations: hasExaminations,
          performs_ecg: hasEcg,
          performs_other_services: hasOtherServices,
          consultation_with_extra_steps: hasVitalSigns || hasExaminations || hasEcg,
        } as IAccountInfo,
        personsInLocation: personsByLocationResponse?.data?.persons,
        merchantPersonId: personsByLocationResponse?.data?.persons?.find(
          (p: any) =>
            p.person_account_number === locationResponse?.data?.location?.location_external_id
        )?.person_external_id,
      };
    } catch (err: any) {
      return rejectWithValue({
        isHealthpoint: err?.response?.data?.person?.is_healthpoint ?? false,
        error: err?.response?.data || 'Something went wrong ',
      });
    }
  }
);

export const getPaymentMethods = createAsyncThunk(
  'user/payment-methods',
  async (_, { dispatch, rejectWithValue, getState }) => {
    const state: any = getState();
    try {
      const getPaymentMethodsResponse: any = await client.get(
        `/healthpoint/payment-methods/${state?.auth?.accountInfo?.account_number}`
      );
      return getPaymentMethodsResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const getAccountInfo = createAsyncThunk(
  'user/account-info',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const accountInfoResponse: any = await client.get('/healthpoint/account-info');
      return accountInfoResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const getPersonsInLocation = createAsyncThunk(
  'persons/locations',
  async (
    location: {
      locationId?: string;
    },
    { dispatch, rejectWithValue, getState }
  ) => {
    const state: any = getState();
    try {
      const personsByLocationResponse: any = await client.get(
        `/healthpoint/persons-in-location/${location.locationId ?? state?.auth?.locationId}`
      );
      return personsByLocationResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const getTimeSlots = createAsyncThunk(
  'user/timeslots',
  async (_, { dispatch, rejectWithValue, getState }) => {
    try {
      const state: any = getState();
      const timeSlotsResponse: any = await client.get(
        `/healthpoint/timeslots/${state?.auth?.accountInfo?.account_number}`
      );
      return timeSlotsResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

type GetProductTimeSlots = {
  timeStamp: string;
  product_id: number;
};
export const getProductTimeSlots = createAsyncThunk(
  'user/productTimeslots',
  async (productTimeSlots: GetProductTimeSlots, { rejectWithValue, getState }) => {
    try {
      const state: any = getState();
      const timeSlotsResponse = await client.get(
        `/core/public/timeslot/merchant/${state?.auth?.accountInfo?.account_number}/day/${productTimeSlots.timeStamp}?product_id=${productTimeSlots.product_id}`
      );
      return timeSlotsResponse.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const putToken = createAsyncThunk('/core/person/fcm', async (token: string) => {
  try {
    await client.put(`/core/person/fcm`, { fcm_token: token });
  } catch (error) {
    console.log('error', error);
  }
});

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    resetLogin: (state) => {
      return {
        ...initialState,
        basicAuth: state.basicAuth,
      };
    },
    logout: (_) => {
      return { ...initialState };
    },
    generateBasicAuth: (
      state,
      {
        payload,
      }: PayloadAction<{
        username: string;
        password: string;
      }>
    ) => {
      return {
        ...state,
        basicAuth: Buffer.from(`${payload.username}:${payload.password}`).toString('base64'),
      };
    },
    setDirtyState: (state, action) => {
      state.isDirtyState = action.payload;
    },
    clearProductTimeslots: (state) => {
      state.productTimeSlots = initialState.productTimeSlots;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        state.role = action.payload.role;
        state.location = action.payload.location;
        state.locationId = action.payload.locationId;
        state.isMerchant = action.payload.isMerchant;
        state.isHealthpoint = action.payload.isHealthpoint;
        state.status = 'idle';
      });
    builder
      .addCase(login.rejected, (state, action) => {
        state.status = 'rejected';

        const payload = action.payload as { isHealthpoint?: boolean; error?: string } | undefined;

        const isHealthpoint = payload?.isHealthpoint;
        const errorMsg =
          isHealthpoint === false
            ? payload?.error || 'Access denied: Not a HealthPoint account.'
            : payload?.error || 'Something went wrong.';

        toast.error(errorMsg, { position: toast.POSITION.BOTTOM_RIGHT });
      })

      .addCase(validateToken.pending, (state) => {})
      .addCase(validateToken.fulfilled, (state, action: any) => {
        state.isLoggedIn = true;

        // state.basicAuth = Buffer.from(`frankfurt.dit+airpoint@ecocare.center:frankfurt`).toString(
        //   'base64'
        // );
        state.person = action.payload.person;
      })
      .addCase(validateToken.rejected, (state, action: any) => {
        state.isLoggedIn = false;
      })
      .addCase(getPaymentMethods.pending, (state) => {})
      .addCase(getPaymentMethods.fulfilled, (state, action) => {
        state.paymentMethods = action.payload.data.paymentMethods;
      })
      .addCase(getPaymentMethods.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong fetching payment methods.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .addCase(getAccountInfo.pending, (state) => {})
      .addCase(getAccountInfo.fulfilled, (state, action) => {
        state.accountInfo = action.payload.data.accountInfo;
      })
      .addCase(getAccountInfo.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong fetching account info.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .addCase(getPersonsInLocation.pending, (state) => {})
      .addCase(getPersonsInLocation.fulfilled, (state, action) => {
        state.personsInLocation = action.payload.data.persons;
      })
      .addCase(getPersonsInLocation.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong fetching account info.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .addCase(getTimeSlots.pending, (state) => {})
      .addCase(getTimeSlots.fulfilled, (state, action) => {
        state.timeSlots = action.payload.data.timeslots;
      })
      .addCase(getTimeSlots.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong fetching time slots.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .addCase(getProductTimeSlots.pending, (state) => {
        state.productTimeSlotsStatus = 'pending';
      })
      .addCase(getProductTimeSlots.fulfilled, (state, action) => {
        if (action.payload && action.payload.length) {
          state.productTimeSlots = [...state.productTimeSlots, ...action.payload];
        }
        state.productTimeSlotsStatus = 'idle';
      })
      .addCase(allInfo.pending, (state) => {})
      .addCase(allInfo.fulfilled, (state, action) => {
        state.location = action.payload.location;
        state.locationId = action.payload.locationId;
        state.businessPartnerId = action.payload.businessPartnerId;
        state.role = action.payload.role;
        state.publicDesignationId = action.payload.publicDesignationId;
        state.personLoggedIn = action.payload.personLoggedIn;
        state.isLoggedIn = action.payload.isLoggedIn;
        state.isMerchant = action.payload.isMerchant;
        state.isHealthpoint = action.payload.isHealthpoint;
        state.paymentMethods = action.payload.paymentMethods;
        state.accountInfo = action.payload.accountInfo;
        state.personsInLocation = action.payload.personsInLocation;
        state.merchantPersonId = action.payload.merchantPersonId;
      })
      .addCase(allInfo.rejected, (state, action: any) => {
        const isHealthpoint = action?.payload?.isHealthpoint;
        const customMessage =
          isHealthpoint === false
            ? 'Access restricted: Only merchants can log into HealthPoint.'
            : action?.payload?.error ?? 'Something went wrong.';
        toast.error(customMessage, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  },
});

export const { resetLogin, logout, generateBasicAuth, setDirtyState, clearProductTimeslots } =
  loginSlice.actions;

export default loginSlice.reducer;

export const selectAuthStatus = (state: RootState) => state.auth.status;
export const selectIsLoggedIn = (state: RootState) => state.auth.isLoggedIn;
export const selectIsMerchant = (state: RootState) => state.auth.isMerchant;
export const selectIsHealthpoint = (state: RootState) => state.auth.isHealthpoint;
export const selectPaymentMethods = (state: RootState) => state.auth.paymentMethods;
export const selectAccountInfo = (state: RootState) => state.auth.accountInfo;
export const selectUserRole = (state: RootState) => state.auth.role;
export const selectUserPublicDesignationId = (state: RootState) => state.auth.publicDesignationId;
export const selectPersonLoggedIn = (state: RootState) => state.auth.personLoggedIn;
export const selectUserLocation = (state: RootState) => state.auth.location;
export const selectTimeSlots = (state: RootState) => state.auth.timeSlots;
export const selectProductTimeSlots = (state: RootState) => state.auth.productTimeSlots;
export const selectProductTimeSlotsStatus = (state: RootState) => state.auth.productTimeSlotsStatus;
export const selectPersonsInLocation = (state: RootState) => state.auth.personsInLocation;
export const selectBasicAuth = (state: RootState) => state.auth.basicAuth;
export const selectBusinessPartnerId = (state: RootState) => state.auth.businessPartnerId;
export const selectMerchantPersonId = (state: RootState) => state.auth.merchantPersonId;
export const selectLocationId = (state: RootState) => state.auth.locationId;
export const selectDirtyState = (state: RootState) => state.auth.isDirtyState;
